import React from 'react';
import Layout, { usePageTitle } from '../components/site/Layout';

export function HowWeWork() {
  usePageTitle('How We Work — Methodology & Affiliate Disclosure | CompareVIN');
  return (
    <Layout>
      <div className="cv-narrow cv-legal">
        <div className="cv-eyebrow">About</div>
        <h1>How we work</h1>
        <p className="cv-lead" style={{ marginTop: 10 }}>CompareVIN is an independent guide to checking a used car. Here is exactly what we do, where the data comes from and how we earn money.</p>

        <h2>Where the vehicle data comes from</h2>
        <p>The free checker uses public NHTSA (National Highway Traffic Safety Administration) data: the vPIC VIN decoder, recall campaigns, owner complaints and NCAP crash-test ratings. We request it live from NHTSA in your browser; we don't store it, and we don't store your VIN.</p>
        <p>NHTSA organises this data by make, model and year. It tells you which recall campaigns and complaints exist for a model year — not whether one particular car has already had a repair done. For that, we send you to NHTSA's own VIN recall lookup.</p>

        <h2>How we choose which reports to recommend</h2>
        <p>Our report guide is editorial. It is based on each provider's published coverage, pricing and policies, and on how well each fits a particular kind of buyer. We consider:</p>
        <ul>
          <li>Where the data comes from, including whether it includes the federal NMVTIS layer.</li>
          <li>Price for one report and at realistic volumes.</li>
          <li>What the report can and can't show (service records, auction history, photos, imports).</li>
          <li>Refund, guarantee and subscription-renewal terms.</li>
        </ul>
        <p>We do not publish numerical test scores, and we do not claim to have run our own lab tests of these services. Prices shown are list prices and change often; always confirm on the provider's site.</p>

        <h2>Affiliate disclosure</h2>
        <p>Some links on this site are affiliate links. If you click one and buy a report, we may earn a commission at no extra cost to you. Those links are marked as sponsored in the page code. The commission is how we pay for keeping the free tools free.</p>

        <h2>Limits</h2>
        <p>A vehicle history report only shows events that someone reported. A clean report is an absence of red flags, not proof of a perfect car, and none of our tools replaces a pre-purchase inspection by a mechanic. Nothing here is legal, financial or safety advice.</p>

        <h2>Corrections</h2>
        <p>Spotted something out of date or wrong? Write to <a href="mailto:support@comparevin.com">support@comparevin.com</a> and we'll fix it.</p>
        <p className="cv-muted" style={{ marginTop: 24, fontSize: 14 }}>CompareVIN is not affiliated with Carfax, AutoCheck, NHTSA, NICB or any provider mentioned.</p>
      </div>
    </Layout>
  );
}

export function Privacy() {
  usePageTitle('Privacy Policy | CompareVIN');
  return (
    <Layout>
      <div className="cv-narrow cv-legal">
        <div className="cv-eyebrow">Legal</div>
        <h1>Privacy policy</h1>
        <p className="cv-muted" style={{ marginTop: 8 }}>Plain-language summary of what happens to your data on comparevin.com.</p>

        <h2>What we don't do</h2>
        <ul>
          <li>We don't ask you to create an account or give an email address.</li>
          <li>We don't store the VINs or vehicle details you enter. Lookups go from your browser directly to NHTSA's public servers.</li>
          <li>We don't sell personal data.</li>
        </ul>

        <h2>Analytics</h2>
        <p>We use Google Analytics 4 to count visitors and see which pages are useful. It sets cookies and collects usage data such as pages viewed, approximate location, device and browser. We don't send it your VIN or any personal information. You can opt out with the Google Analytics opt-out browser add-on or by blocking cookies in your browser.</p>

        <h2>Third-party sites and affiliate links</h2>
        <p>When you click through to a report provider, you leave our site. Those providers, and the affiliate networks we use, may set their own cookies to track that the visit came from us. Their privacy policies apply from that point.</p>
        <p>Vehicle data comes from NHTSA. Their servers receive the request your browser makes when you run a check, including your IP address, as with any website visit.</p>

        <h2>If you submit the Get listed form</h2>
        <p>We receive the details you type in (company, contact name, email, message) and use them only to review and answer your submission. If the form is unavailable it opens a pre-filled email instead, which your own email provider handles.</p>

        <h2>Your rights</h2>
        <p>Depending on where you live (for example under GDPR or the CCPA), you may have rights to access or delete personal data. Because we hold almost none, there is generally nothing to delete, but you can write to us at any time.</p>

        <h2>Contact</h2>
        <p><a href="mailto:support@comparevin.com">support@comparevin.com</a></p>
      </div>
    </Layout>
  );
}
